<div class="col col-md-12" *ngIf="loading">
    <div class="spinner-container">
        <ngx-spinner name="spinnerGrafico" bdOpacity=0.3bd
            Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
            <p style="color: white">C a r g a n d o . . . </p>
        </ngx-spinner>
    </div>
</div>

<div class="card add-margin" *ngIf="!loading">
    <form [formGroup]="dataForm">
        <div style="align-items: center;" class="card-header d-flex bg-light">
            <h4 class="modal-title flex-grow-1 p-2">Información:</h4>
            <button *ngIf="!estaEditandoAsignacion()" type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
        </div>

        <div class="card-body p-3">

            <!-- nombre -->
            <div class="container">
                <div class="row">
                    <div class="mb-3 row col-12">
                        <label for="nombreFormControl" class="col-2 col-form-label">*Nombre de Asignación:</label>
                        <div class="col-8">
                            <input id="nombreFormControl" formControlName="nombreFormControl" type="text"
                                class="form-control" />
                            <div *ngIf="nombreFormControl.invalid && nombreFormControl.errors.required && (nombreFormControl.dirty || nombreFormControl.touched)"
                                class="alert alert-danger">Requerido
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>

            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="card">
                            <div class="card-header">
                                <h5 class="text-center">Solicitante</h5>
                            </div>
                            <div class="card-body">
                                <div class="d-flex">
                                    <select class="form-select" id="rolSolicitanteFormControl" formControlName="rolSolicitanteFormControl">
                                        <option [value]="null" disabled defaultselected>
                                            Seleccione un rol
                                        </option>
                                        <option *ngFor="let rol of todosLosRolesSolicitados" [ngValue]="rol">
                                            {{ rol.nombre }}
                                        </option>
                                    </select>
                                    <button type="button" ngbTooltip="Agregar rol asignado" (click)="agregaRolSolicitante()" class="btn btn-success ms-2 px-1">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </div>
                                <hr>

                                <div class="item-border">
                                    <div *ngFor="let r of rolesSolicitados; let i=index">
                                        <div class="d-flex mt-1">
                                            <label class="col-11 col-form-label">{{ r.nombre }}</label>
                                            <button type="button" ngbTooltip="Quitar rol asignado" (click)="quitarRolSolicitante(r)" class="btn btn-danger ms-2 px-1">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div *ngIf='rolesSolicitados.length === 0' class="alert alert-warning mt-3" role="alert">No se han cargado roles solicitantes</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card">
                            <div class="card-header">
                                <h5 class="text-center">Aprobador</h5>
                            </div>
                            <div class="card-body">
                                <div class="d-flex">
                                    <select class="form-select" id="rolAprobadorFormControl" formControlName="rolAprobadorFormControl">
                                        <option [value]="null" disabled defaultselected>
                                            Seleccione un rol
                                        </option>
                                        <option *ngFor="let rol of todosLosRolesAprobadores"  [ngValue]="rol">
                                            {{ rol.nombre }}
                                        </option>
                                    </select>
                                    <button type="button" ngbTooltip="Agregar rol asignado" (click)="agregaRolAprobador()" class="btn btn-success ms-2 px-1">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </div>
                                <hr>

                                <div class="item-border">
                                    <div *ngFor="let r of rolesAprobadores; let i=index">
                                        <div class="d-flex mt-1">
                                        <label class="col-11 col-form-label">{{ r.nombre }}</label>
                                        <button type="button" ngbTooltip="Agregar rol asignado" (click)="quitarRolAprobador(r)" class="btn btn-danger ms-2 px-1">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                        </div>
                                    </div>
                                    <div *ngIf='rolesAprobadores.length === 0' class="alert alert-warning mt-3" role="alert">No se han cargado roles aprobadores</div>
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
            <br>

            <div *ngIf="error != null" class="row col-md-12 alert alert-danger">
                {{error}}
            </div>
        </div>
        <div class="card-footer d-flex justify-content-center">
            <span class="border">
                <button type="button" class="btn btn-primary" (click)="guardarCambios()"
                    [disabled]="guardandoDatos || authService.hasRole(TipoUsuario.SOPORTE)">
                    <span *ngIf="!guardandoDatos">Guardar cambios</span>
                    <div *ngIf="guardandoDatos" class="d-flex align-items-center">
                        <div class="spinner-border text-light spinner-border-sm" role="status"></div>
                        <span>Guardando...</span>
                    </div>
                </button>
            </span>
        </div>
    </form>
</div>